export enum QueryKeys {
    SHIPPING_RULES = 'SHIPPING_RULES',
    SHIPPING_RULES_SERVICES_AVAILABLE = 'SHIPPING_RULES_SERVICES_AVAILABLE',
    SHIPPING_RULES_DESTINATIONS = 'SHIPPING_RULES_DESTINATIONS',
    SHIPPING_RULES_SOURCES = 'SHIPPING_RULES_SOURCES',
    SHIPPING_RULES_WAREHOUSES = 'SHIPPING_RULES_WAREHOUSES',
    SHIPPING_RULES_PARCELS = 'SHIPPING_RULES_PARCELS',
}
